import { RootState } from "store";

export const isAuth = (state: RootState) => state.auth.isAuth;
